export default __webpack_public_path__ + "static/media/img-hero-desktop-04-bassic.828648e9.jpg";